export default "__VITE_ASSET__BRKsH_3z__"